export const Level = {
  Beginner: "beginner",
  Intermediate: "intermediate",
  Advanced: "advanced",
} as const;

export type Level = (typeof Level)[keyof typeof Level];

export const LEVELS: Level[] = [Level.Beginner, Level.Intermediate, Level.Advanced];

// RGB hex color values for audience level borders. They match the web Tailwind classes:
// Beginner lime-600, Intermediate amber-400, Advanced orange-500.
export const AUDIENCE_LEVEL_COLORS: Record<Level, string> = {
  [Level.Beginner]: "#65a30d",
  [Level.Intermediate]: "#fbbf24",
  [Level.Advanced]: "#f97316",
};

export const getAudienceLevelColor = (level: Level): string => {
  return AUDIENCE_LEVEL_COLORS[level] ?? AUDIENCE_LEVEL_COLORS[Level.Beginner];
};
